import { FrameworkActionCreator } from 'src/store/states';

let idleListener: ((e: Event) => void) | undefined = undefined;

/**
 * Add a window listener for the storage.
 * @param store
 */
export const createIdleListener = (store) => {
    const { dispatch } = store;
    const shouldActivityUpdate = createShouldActivityUpdate(store);

    idleListener = (e: Event) => {
        if (!shouldActivityUpdate(e)) {
            return;
        }
        dispatch(FrameworkActionCreator.resetTimer());
        e.stopPropagation();
    };

    window.addEventListener('keydown', idleListener);
    window.addEventListener('click', idleListener);
};

/** When trying to get a token with different access.  Trying to check the token being discarded is problematic. */
const destroyIdleListener = () => {
    if (idleListener) {
        window.removeEventListener('keydown', idleListener);
        window.removeEventListener('click', idleListener);
    }
};

const createShouldActivityUpdate = (store) => ({ type, key='' }) => {
    /** If last event was not the same event type, trigger an update. */
    const { isLoggedIn } = store.getState().Framework;

    if (isLoggedIn === false || isLoggedIn === undefined) {
        return false;
    }

    if (type === 'keydown' && key !== 'Tab' && key !== 'Enter') {
        return false;
    }

    return true;
};


/**
 * Dispatch Idle then push next action
 * @param store
 */
export const idleMiddleware = () => (next) => (action) => {
    if (action && action.type === 'LOGOUT') {
        destroyIdleListener();
    }

    return next(action);
};
